import { render, staticRenderFns } from "./SelectedItemModal.vue?vue&type=template&id=2a48f497&"
import script from "./SelectedItemModal.vue?vue&type=script&lang=js&"
export * from "./SelectedItemModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports